import OfferSelectors from './offer';
import { createSelector } from 'reselect';

export default class UserSelectors {
    static getMyself = (state) => state.myself;

    static getMapUsername = (state) => state.user.mapUsername;

    static getLookupInProgress = (state) => state.user.lookupInProgress;

    static getLookupFinished = (state) => state.user.lookupFinished;

    static getSummaries = (state) => state.user.userSummaries;

    static getSummariesInTransit = (state) => state.user.userSummariesInTransit;

    static getSpoofInProgress = (state) => state.user.spoofInProgress;

    static getPreferences = createSelector(
        UserSelectors.getMyself,
        (user) => (user ? user.preferences : null)
    );

    static getSpoofer = createSelector(
        UserSelectors.getMyself,
        (user) => (user ? user.spoofer : null)
    );

    static getSpoofEnabled = createSelector(
        UserSelectors.getSpoofer,
        (spoofer) => Boolean(spoofer)
    );

    static getSortedSummaries = createSelector(
        UserSelectors.getSummaries,
        (summaries) =>
            summaries.slice().sort((a, b) => {
                const compare = (x, y) =>
                    x.toLowerCase().localeCompare(y.toLowerCase());
                const comparisons = [
                    () => compare(a.firstName, b.firstName),
                    () => compare(a.lastName, b.lastName),
                    () => -1,
                ];

                return comparisons.find((f) => f() !== 0)();
            })
    );

    static getMyselfIsAdmin = createSelector(
        UserSelectors.getMyself,
        UserSelectors.getSpoofer,
        (user, spoofer) => {
            if (!user) {
                return false;
            }

            const isAdmin = (role) =>
                ['super', 'admin', 'com', 'developer'].indexOf(
                    role.name.toLowerCase()
                ) >= 0;

            if (spoofer) {
                return Boolean(spoofer.roles.find((role) => isAdmin(role)));
            }
            return Boolean(user.roles.find((role) => isAdmin(role)));
        }
    );

    static getFavorites = createSelector(
        OfferSelectors.getSelectedOffer,
        UserSelectors.getPreferences,
        (offer, preferences) => {
            if (preferences && offer) {
                return preferences[`favorites${offer.mentorId}`];
            }
            return null;
        }
    );

    static getFavoriteSite = createSelector(
        UserSelectors.getFavorites,
        (favorites) => (favorites ? favorites.site : null)
    );

    static getFavoriteServer = createSelector(
        UserSelectors.getFavorites,
        (favorites) => (favorites ? favorites.server : null)
    );

    static getFavoriteSiteIndex = createSelector(
        OfferSelectors.getServersGroupedBySite,
        UserSelectors.getFavoriteSite,
        (serversBySite, siteId) => {
            if (siteId) {
                var index = serversBySite.findIndex((site) => site.id == siteId);
                return index >= 0 ? index : 0; // Default to first site if favorite site not found
            }
            return 0;
        }
    );

    static getFavoriteServerIndex = createSelector(
        OfferSelectors.getServersGroupedBySite,
        UserSelectors.getFavoriteSiteIndex,
        UserSelectors.getFavoriteServer,
        (serversBySite, siteIndex, serverId) => {
            if (siteIndex > -1 && serverId) {
                var index = serversBySite[siteIndex].servers.findIndex(
                    (server) => server.id == serverId
                );
                return index >= 0 ? index : 0; // Default to first server if favorite server not found
            }
            return 0;
        }
    );

    static getServerAliases = createSelector(
        UserSelectors.getPreferences,
        (preferences) =>
            preferences && preferences.serverAliases
                ? preferences.serverAliases
                : {}
    );
}



// WEBPACK FOOTER //
// ./app/selectors/user.js